import React, { useContext, useState } from 'react';
import { UPDATE_USER } from 'src/graphql';
import { useMutation } from '@apollo/client';
import { PrimaryButton } from 'src/components';
import { Card, Row, Col, Typography } from 'antd';
import { errorMessage, successMessage } from 'src/utils/Notifications';
import { UserContext } from 'src/utils/UserContext';
import { getToken, setToken } from 'src/services';
import { IAuth, IUser } from 'src/interfaces';
import UploadComponent from '../components/UploadComponent';

const { Title, Text } = Typography;
export type ProfileImageProps = {
    isAdmin: boolean;
    userId?: string | undefined;
    manageUser?: boolean;
    userDetailsPhotoSrc?: string;
};

function ProfileImage({ userId, manageUser, userDetailsPhotoSrc, isAdmin }: ProfileImageProps): JSX.Element {
    const userContext = useContext(UserContext);
    const [photo, setPhoto] = useState<string>('');
    const [updateProfilePic, { loading }] = useMutation(UPDATE_USER);
    const roleId = isAdmin? "ADMIN": "CLIENT";
    const handleUpdate = () => {
        if (photo.length > 5) {
            updateProfilePic({
                variables: {
                    update: {
                        photo,
                        roleId
                    },
                    userId,
                },
               })
                .then(() => {
                    if (!manageUser) {
                        const data = getToken();
                        const newData: IAuth = {
                            ...data,
                            user: {
                                ...data.user,
                                photo,
                            } as IUser,
                        };
                        setToken(newData);
                        userContext.setUserState(newData.user as IUser);
                    }

                    successMessage('Profile picture updated successfully');
                })
                .catch(() => {
                    errorMessage('Failed to update profile picture');
                });
        } else {
            errorMessage('Upload a New Photo');
        }
    };

    return (
        <div style={{padding:"5px", marginLeft:"5px", marginRight:"5px", background: '#ffffff', borderRadius: "15px"}}>      
          <Row>
               <Col span="24" style={{paddingLeft:"10px", paddingTop:"10px"}}><Text className="card-heading">Profile Image</Text></Col> 
               <Col span="24" style={{marginTop:"-27px", paddingLeft:"10px"}}><Text style={{fontWeight:"bold", fontSize:"20px", color:"#EE773B"}}>___</Text></Col> 
          </Row>
          <Card className="card" style={{padding:"0px", margin:"0px"}}>
            <Row style={{padding:"0px"}}>
               <Col span="24" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} style={{textAlign:"center", alignItems: 'center', paddingTop:"0px"}}>
                 <UploadComponent text="" getUrl={setPhoto} userDetailsPhotoSrc={userDetailsPhotoSrc} handleUpdate={handleUpdate} loading={loading} /></Col>
            </Row>
        </Card>
       </div>
    );
}

export default ProfileImage;
